<template>
	<v-card
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>
		<v-card-text>
			<v-form ref="form">
				<h4 class="my-3">Вам необхідно підготувати фото чи скан копії наступних документів:</h4>
				<ol class="text-left">
					<li>Паспорт або ID Паспорт (водія та власника авто).</li>
					<li>Ідентифікаційний номер (водія та власника авто).</li>
					<li>Посвідчення водія чи тимчасового дозволу.</li>
					<li>Свідоцтво про реєстрацію транспортного засобу.</li>
					<li>Поліс страхування.</li>
					<li>Європротокол чи документи компетентних органів.</li>
					<li>Фото та відео матеріали з місця ДТП.</li>
					<li>Повідомлення про подію;</li>
					<li>Заява від потерпілого власника авто про виплату страхового відшкодування (бланки повідомлення та заяви ви зможете скачати далі)</li>
				</ol>
				<h4 class="my-3">Для юридичних осіб потерпілих необхідно надати:</h4>
				<ol class="text-left">
					<li>Пакет документів для проходження фін. моніторингу;</li>
					<li>Витяг з ЄДР;</li>
				</ol>
				<h4 class="my-3"><i>В разі наявності документів пов'язаних з подією, поза зазначеним переліком, ви можете їх завантажити у папку "інші документи"</i></h4>
				<h4 class="my-3">УВАГА!<br>Максимальний розмір одного файлу до 20 Мб.</h4>
				<h4 class="my-3">Скріншоти документів не приймаються, тільки фото або скан-копії</h4>
				<h4 class="my-3">Завантажуйте документи виключно у відповідні категорії</h4>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import mixin from './mixin/main'

export default {
	mixins: [mixin],
	//components: { zOferta },

	/* computed: {
		title() {
			return 'Вітаємо!'
		},
	}, */
}
</script>
